import React, { Component } from "react";
import { injectIntl } from "react-intl";

import { Button } from "cxa-components";
import messages from "components/messagesDescription";

class HraResultIncomplete extends Component {
  render() {
    const { intl } = this.props;

    // TODO: On 1.5, prefer to use a notification component
    return (
      <div>
        <p>{intl.formatMessage(messages.healthAssessmentMustComplete)}</p>
        <p>
          <Button primary type="button" to="/wellness/lifestyleAgeing/questionnaire/1">
            {intl.formatMessage(messages.okTextDescription)}
          </Button>
        </p>
      </div>
    );
  }
}

export default injectIntl(HraResultIncomplete);



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/results/hraResultIncomplete.jsx